// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PieChartOutlinedSvg from "@ant-design/icons-svg/es/asn/PieChartOutlined";
import AntdIcon from '../components/AntdIcon';

var PieChartOutlined = function PieChartOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PieChartOutlinedSvg
  }));
};

PieChartOutlined.displayName = 'PieChartOutlined';
export default React.forwardRef(PieChartOutlined);